import { IAdvisoryPropertiesV3 } from '@autopylot-internal/tiles-client';
import { SecondaryWarningAdvisory } from '../SecondaryAdvisory.tsx';
import { AdvisoryLink } from './AdvisoryLink.tsx';

export interface ICompositeMTRAdvisoryProperties extends IAdvisoryPropertiesV3 {
    advisoryType: 'advise';
    source: 'military-training-routes+composite';
    routeNumbers: string[];
}

export const MilitaryTrainingRoutesAdvisory = (props: ICompositeMTRAdvisoryProperties & { near?: boolean}) => {
    const distinctNumbers = Array.from(new Set(props.routeNumbers));
    return (
        <SecondaryWarningAdvisory header="Special Use Airspace" advisoryType={props.advisoryType}>
            <>
                <p>
                    Your mission {props.near ? 'is within 2 NM of': 'overlaps'} <strong>Military Training Route{distinctNumbers.length > 1 ? 's' : ''} {distinctNumbers.join(', ')}</strong>. This airspace may contain more air traffic
                    or fast military aircraft. Maintain extra vigilance and awareness when flying.
                </p>
                <p>
                    Prior to flight, the remote pilot in command must assess local airspace and any flight restrictions.
                </p>
                <p>
                    <AdvisoryLink url="https://sua.faa.gov" />
                </p>
            </>
        </SecondaryWarningAdvisory>
    );
};
